/** Frontend production config copied into each release before Expo export. */
const secrets = {
  apiBaseUrl: "https://tasksbackend.diestoeckels.de",
  apiBasePort: 4182,
  tensorbuzzBugReporting: {
    authToken: "0fb3daad5b704ac1b180a74d53c1e532",
    hostname: "tasks.diestoeckels.de",
    postUrl: "https://server.tensorbuzz.com/errors/reports",
    release: null,
    runtimeEnvironment: "frontend"
  }
}

export default secrets
